import Lookup from 'src/componentes/select2';

const ConvenenteLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/ConvenenteLookup"
    clearable={true}
    {...rest}
  />
);

export default ConvenenteLookup;
